<template>
  <page>
    <page-title>{{ currentClient.name }}</page-title>
    <nav-bar>
      <nav-bar-link
        v-if="hasRoleOwner"
        :to="{ name: 'ClientSettings' }"
        :label="$t('p.clientPage.navigation.settings')"
        icon="cog"
      />

      <nav-bar-link
        :to="{ name: 'ClientTags' }"
        :label="$t('p.clientPage.navigation.tags')"
        icon="tags"
      />


      <nav-bar-link
        :to="{ name: 'ClientTheme' }"
        :label="$t('p.clientPage.navigation.theme')"
        icon="paint-brush"
      />

      <nav-bar-link
        :to="{ name: 'ClientMembers' }"
        :label="$t('p.clientPage.navigation.members')"
        icon="users"
      />

      <nav-bar-link
        :to="{ name: 'ClientInvitations' }"
        :label="$t('p.clientPage.navigation.invitations')"
        icon="envelope"
      />
    </nav-bar>
    <router-view />
  </page>
</template>

<script>
import NavBarMixin from '@/mixins/ui/NavBar'
import PageMixin from '@/mixins/pages/Page'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ClientPage',
  mixins: [NavBarMixin, PageMixin],
  computed: {
    ...mapState ({
      currentUser: state => state.currentUser.currentUser,
    }),
    ...mapGetters ({
      currentClient: 'currentClient'
    }),
    hasRoleOwner () {
      return this.currentUser.role === 'owner'
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        if ($route.path === '/client') {
          const routeName = this.hasRoleOwner
            ? 'ClientSettings'
            : 'ClientTags'
          this.$router.push({ name: routeName })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/ClientPage.vue